var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-chip",
    {
      attrs: {
        color: _vm.delegationStatusExtended.find(function(v) {
          return v.value === _vm.status
        }).color,
        "text-color": "white"
      }
    },
    [
      _vm._v(
        " " +
          _vm._s(
            _vm.delegationStatusExtended.find(function(v) {
              return v.value === _vm.status
            }).text
          ) +
          " "
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }